import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()

export const getFormattedDateTime = ({
  dateTime,
  isTimeRequired = false,
  isYearRequired = false,
  isDayRequired = false,
  isFullMonthName = true,
  propertyLocaleCode = i18nUtils.getLocale(),
  dateTimeSeparator = ', ',
  isLongFormat = false,
  hideDay = false, // To hide day string like Mon, Tues
}) => {
  let { format } = i18nUtils.getDateUtils()
  const isCNCountryCode = propertyLocaleCode?.split('_')[1] === 'CN'
  if (propertyLocaleCode && propertyLocaleCode !== i18nUtils.getLocale()) {
    const locale = propertyLocaleCode?.split('_')?.join('-') || 'en-US'
    format = i18nUtils.getDateUtils(locale)?.format
  }
  const day = isDayRequired ? 'ddd,' : ''
  let date

  switch (format) {
    case 'DD/MM/YYYY':
      date = __('{%s, 0}', [
        isRP
          ? i18nUtils.datetime(
              dateTime,
              `${hideDay ? '' : isLongFormat ? 'dddd' : 'ddd'} ${
                isLongFormat ? 'MMMM' : 'MMM'
              } DD${isYearRequired ? ', YYYY' : ''}`,
            )
          : i18nUtils.datetime(dateTime, 'DD MMMM YYYY'),
      ])
      break

    case 'MM/DD/YYYY':
      date = __('{%s, 0}', [
        isRP
          ? i18nUtils.datetime(
              dateTime,
              `${hideDay ? '' : isLongFormat ? 'dddd' : 'ddd'} ${
                isLongFormat ? 'MMMM' : 'MMM'
              } DD${isYearRequired ? ', YYYY' : ''}`,
            )
          : i18nUtils.datetime(
              dateTime,
              `${day} ${isFullMonthName ? 'MMMM' : 'MMM'} D${
                isYearRequired ? ', YYYY' : ''
              }`,
            ),
      ])
      break

    case 'YYYY/MM/DD':
      date = __('{%s, 0}', [
        isRP
          ? i18nUtils.datetime(
              dateTime,
              `${hideDay ? '' : isLongFormat ? 'dddd' : 'ddd'} ${
                isLongFormat ? 'MMMM' : 'MMM'
              } DD${isYearRequired ? ', YYYY' : ''}`,
            )
          : i18nUtils.datetime(
              dateTime,
              `${day} ${isYearRequired ? 'YYYY' : ''} ${
                isFullMonthName ? 'MMMM' : 'MMM'
              }, D`,
            ),
      ])
      break

    case 'YYYY-MM-DD':
      date = __('{%s, 0}', [
        isRP
          ? i18nUtils.datetime(
              dateTime,
              `${hideDay ? '' : isLongFormat ? 'dddd' : 'ddd'} ${
                isLongFormat ? 'MMMM' : 'MMM'
              } DD${isYearRequired ? ', YYYY' : ''}`,
            )
          : i18nUtils.datetime(dateTime, 'YYYY-MM-DD'),
      ])
      break

    default:
      date = __('{%s, 0}', [
        isRP
          ? i18nUtils.datetime(
              dateTime,
              `${hideDay ? '' : isLongFormat ? 'dddd' : 'ddd'} ${
                isLongFormat ? 'MMMM' : 'MMM'
              } DD${isYearRequired ? ', YYYY' : ''}`,
            )
          : i18nUtils.datetime(
              dateTime,
              `${day} ${isFullMonthName ? 'MMMM' : 'MMM'} D ${
                isYearRequired ? ', YYYY' : ''
              }`,
            ),
      ])
      break
  }

  if (isTimeRequired) {
    return (
      date.trim() +
      dateTimeSeparator +
      (isCNCountryCode
        ? i18nUtils.datetime(dateTime, 'H:mm')
        : i18nUtils.datetime(dateTime, 'h:mm a'))
    )
  }
  return date.trim()
}
